import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(public auth: AuthService, public router: Router) { }

  async canActivate() {

    var result =  await this.auth.isAuthenticated();

    if (!result){

      //redirect to logout/login
      this.router.navigateByUrl('/login')

      return false;
    }
    return true;
  }
}
